import {Icons} from '@pb/kit-component-icon';

export const NAV_ITEMS = [
    {label: 'Vendor Portal', icon: Icons.PEOPLE_ICON, path: '/vendor-admin/pending', toolCode: 'eva'},
    {label: 'SSO Settings', icon: Icons.SETTINGS, path: '/sso-settings', toolCode: 'sso'},
    {label: 'Access Management', icon: Icons.ID_BADGE, path: '/access-management', toolCode: 'iam'},
];
